module.exports = __webpack_public_path__ + "b257fa9c5ac8c515ac4d77a667ce2943.svg";